module.exports = __webpack_public_path__ + "media/images/registrations/info_version/info-2-9511c12af8f0c2ed4dc38eaee44b0cc5.png";